import React from "react";

import { CommonConfigContext } from "../../components/CommonConfigProvider";

/**
 * Hook to access the CommonConfigContext value.
 *
 * @returns The CommonConfigContext value.
 * @throws Will throw an error if used outside of a CommonConfigContext
 * provider.
 * @example
 * const commonConfig = useCommonConfig();
 */
function useCommonConfig() {
  const commonConfig = React.useContext(CommonConfigContext);

  if (commonConfig === undefined) {
    throw new Error(
      "useCommonConfig must be used within a CommonConfigContext provider."
    );
  }

  return commonConfig;
}

export default useCommonConfig;
